import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.16.1_@biomejs+biome@1.9.4_@capacitor+preferences@6.0.3_@capacitor+core@7.2.0__@parcel+_go4yut2s5v2w5z5dch6spgajqi/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}